import React, { Component, lazy, Suspense } from 'react'
import { Route, Switch, withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import './GBPortal.css'
import includes from 'lodash/includes';
import FiosRegistrationPage from '../../Common/RegistrationPage/fiosRegistrationPage'
//import FloatingCart from '../../Common/FloatingCart/FloatingCart'
//import BundleFloatingCart from '../../Common/FloatingCart/BundleFloatingCart'
import OutofFranchise from '../AddressValidationPage/OutofFranchise/OutofFranchise'
import AddressValidationPage from '../AddressValidationPage/AddressValidationPage'
//import ReviewOrder from '../ReviewOrderPage/ReviewOrder';
//import BundleOffers from '../BundleOffers/BundleOffers';
//import Confirmation from '../Confirmation/Confirmation'
//import OptixConfirmation from '../Confirmation/OptixConfirmation';
import AbandonedCart from '../AbandonedCartTool/AbandonedCart';
// import ContactRep from '../Checkout/ContactRep/ContactRep';
import ConfirmationContactRep from '../Checkout/ConfirmationContactRep/ConfirmationContactRep';
import { withTranslation } from 'react-i18next';

import {
	initiateGlobalSession,
	getApigeeToken,
	getZipcodes,
	selectThisZipcode,
	getStreetAddress,
	selectThisStreetAddress,
	getUnits,
	getUnitsByUnitterm,
	selectThisUnit,
	showCheckAvailability,
	savePhoneNumber,
	savePriceQuoteNumber,
	saveEmailAddress,
	triggerAddressQualification,
	triggerOptixAddressQualification,
	clearGlobalStore,
	clearFaqContent, saveOptixMonNumber, saveConversationInfo, setConversationID,
	getMultipleAddrSelections,
	postEventLogging,
	setIsExternalAppRedirection
} from '../../containers/actions';
import Notification from '../../Common/GlobalNotification/GlobalNotification'
import { getcartInfo } from './../ReviewOrderPage/containers/actions';
import { getRetrieveOrder, redirectLBOPage } from './../CustomizeOrder/containers/actions';
import PendingOrderContact from '../AddressValidationPage/PendingOrderContact/PendingOrderContact'
//import Checkout from '../Checkout/Checkout';
//import OptixCheckout from '../OptixCheckout/OptixCheckout';
import { Grid, Col, Row } from '@vds/grids';
import { Loader } from '@vds/loaders';
import queryString from "query-string";
import styled from 'styled-components';
import SaveCart from '../SaveCart/SaveCart';
import SaveCartConfirmation from '../SaveCart/SaveCartConfirmation';
import { ERROR_MESSAGE } from './../../containers/constants';
import FaqModal from '../../Common/FaqModal/FaqModal';
import { setChatInfo } from '../../utils/common'
import { ENABLE_OMNI_CART } from './../../containers/constants';
import RetrievePendingOrder from '../AddressValidationPage/RetrievePendingOrder/RetrievePendingOrder'
import RetrieveExistingService from '../AddressValidationPage/RetrieveExistingService/RetrieveExistingService'
import ContactUs from '../AddressValidationPage/ContactUs/ContactUs';
import InternetOptions from '../AddressValidationPage/InternetOptions/InternetOptions'
import InternetServices from '../AddressValidationPage/InternetServices/InternetServices'
import ThankYou from '../AddressValidationPage/ThankYou/ThankYou';
import * as SiteAnalytics from '../../sitecatalyst';
import { getQulaificationDetails } from '../AddressValidationPage/containers/action';
import OrderconfirmationNew from '../OrderConfirmationNew/Container/OrderconfirmationNew';
import Qualification from '../AddressValidationPage/Qualification/Qualification';

const FiveGPlanPage = lazy(()=>import('../FiveGPlans/FiveGPlan'));
const CBandPlanPage = lazy(()=>import('../CBandPlans/CBandPlan'));
const FourGPlanPage = lazy(()=>import('../FourGPlans/FourGPlan'));
const BulkAddressUploadPage = lazy(() => import('../BulkAddressUpload/BulkAddressUploadPage'));
const InternetPlanStatic = lazy(() => import('../FourGPlans/InternetPlanStatic'));

const CustomizeOrderPage = lazy(() => import('../CustomizeOrder/CustomizeOrderPage'));
const OptixCheckout = lazy(() => import('../OptixCheckout/OptixCheckout'));
const Checkout = lazy(() => import('../Checkout/Checkout'));
const Confirmation = lazy(() => import('../Confirmation/Confirmation'));
const OptixConfirmation = lazy(() => import('../Confirmation/OptixConfirmation'));

const StyledContainer = styled.div`
  width: 100%;
  max-width: 1272px;
  margin: 0 auto;
`;

let isChatOpened = false;
class GBPortal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			useStyles: { top: 0 }
		}
		this.checkInitated = false;
		setChatInfo();
		const values = queryString.parse(this.props.location.search);
		const scartId = values && values.scartid;
		const monNo = values && values.MON;
		const cid = values && values.cid;
		const cmp = values && values.cmp;
		const orderNumber = values && values.orderNumber;
		const source = values && values.source;  
		const SMBBANNERID = values && values.SMBBANNERID;
		window.qualificationRetry = 0;
		if (scartId || cid) {
			if (includes(window.location.href, 'pendingOrder') || includes(window.location.href, 'ExistingService')) {
				this.props.setIsExternalAppRedirection(true);
				props.getQulaificationDetails({ scartId: scartId, history: this.props.history, monNO: monNo, cid: cid,orderNumber : orderNumber, fromCOP: true, source });
			} 
			else if(props.history?.location?.pathname === "/customize-order" || props.history?.location?.pathname === "/checkout") {
				this.props.setIsExternalAppRedirection(false);
				this.props.getRetrieveOrder({ scartId: scartId, history: this.props.history, monNO: monNo, cid: cid , cmp: cmp});
			}
			
		}
	}
	checkIfStickyExist = () => {
		const paths = ['/customize-order', '/checkout'];
		const { pathname } = this.props.location;
		if (paths.includes(pathname) && this.props.toggleGlobalErrorMessage) {
			this.setState({
				useStyles: { top: '100px' }
			});
			this.checkInitated = true;
		}
	}

	componentDidMount() {
		if(this.props?.isCreditCheckLBO){
			this.props.redirectLBOPage('CREDITFRAUDALERTLBO');
		}
		window.onerror = (event, source, lineNo, colNo, error) => {
			const data = {
				log: error?.stack,
				comments: error?.message,
				eventType: "Error"
			};
			this.props.postEventLogging(data);
		};
		// this.isChatWindowInitiated();
	}

	componentWillReceiveProps(props) {
		if (this.props !== props && !isChatOpened) {
			this.isChatWindowInitiated();
		}
	}

	isChatWindowInitiated = () => {
		const localThis = this;
		try {
			if (typeof window.lpTag === 'undefined') {
				window.setTimeout(function () {
					localThis.isChatWindowInitiated();
				}, 300);
			} else {
				window.lpTag.events.bind("lpUnifiedWindow", "state", this.trackConvInfo);
			}
		} catch (Err) {
			console.log(Err)
			console.log('Chat Window.lpTag not rendered');
		}
	}

	trackConvInfo = (data, eventInfo) => {
		const localThis = this;
		if (window.console && window.JSON) {
			if (data.state == 'init') {
				window.setTimeout(function () {
					isChatOpened = true;
					const converId = window.lpTag?.external?.convInfo?.getData();
					console.log('isChatInitiated', converId)
					if(converId.latestConvId){	
						SiteAnalytics.trackChatId(converId.latestConvId);	
					}
					localThis.getChatConvId(converId);
				}, 3000);
			}
		}
	}



	componentDidCatch(error, errorInfo) {
		const data = {
			log: error,
			comments: errorInfo?.componentStack,
			eventType: "Error"
		};
		this.props.postEventLogging(data);
	}

	handleFaqModalChange = (value) => {
		if (!value) {
			this.props.clearFaqContent();
		}
	}


	getChatConvId = (ConvData) => {
		let latestConvId = ConvData?.latestConvId ? ConvData?.latestConvId : '';
		if (window.lpTag && latestConvId !== '' && latestConvId !== this.props.latestConvId) {
			this.props.setConversationID(latestConvId);
			this.props.saveConversationInfo(latestConvId);

		}
	}

	render() {
		if (!this.checkInitated) this.checkIfStickyExist();
		return (
			<div className="GBportal">
				{!!this.props.faqContent ? <FaqModal showFaqModal={!!this.props.faqContent} onOpenedChange={this.handleFaqModalChange} faqContent={this.props.faqContent} /> : ''}
				<StyledContainer>
					<Grid colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
						<Row>
							<Col>
								<Notification
									show={this.props.toggleGlobalErrorMessage && this.props.toggleGlobalErrorMessage.enableNotification}
									type="error"
									message={(this.props.toggleGlobalErrorMessage && this.props.toggleGlobalErrorMessage.message) ?
										this.props.toggleGlobalErrorMessage.message : ERROR_MESSAGE.GENERIC_MESSAGE}
									// onCloseAction={toggleGlobalErrorMessage}
									useStyles={this.state.useStyles}
								/>
								<Switch location={this.props.location}>
									<Route exact path="/" render={() => <AddressValidationPage {...this.props} />} />
									<Route exact path="/qualification-results" render={() =>  <Qualification {...this.props} />} />
									<Route exact path="/contact" component={ContactUs} />
									<Route exact path="/Thank-you" component={ThankYou} />
									{/* <Route exact path="/customize-order" render={() => <CustomizeOrderPage {...this.props} />} /> */}
									<Route exact path="/customize-order" render={() => (<Suspense fallback={<div className="loading-spinner">
										<Loader active fullscreen disableFocusLock />
									</div>}> <CustomizeOrderPage {...this.props} location={this.props.location.search}/> </Suspense>)} />
									<Route exact path="/fios-registration" component={FiosRegistrationPage} />
									<Route exact path="/out-of-franchise" component={OutofFranchise} {...this.props} />
									<Route exact path="/pending-order" component={PendingOrderContact} />
									{/* <Route exact path="/review-order" component={ReviewOrder} />
									<Route exact path="/bundle-offers" component={BundleOffers} /> */}
									<Route exact path="/checkout" render={() => (<Suspense fallback={<div className="loading-spinner">
										<Loader active fullscreen disableFocusLock />
									</div>}> <Checkout {...this.props} /> </Suspense>)} />
									{ENABLE_OMNI_CART === "true" ? <Route exact path="/optix-checkout" render={() => (<Suspense fallback={<div className="loading-spinner">
										<Loader active fullscreen disableFocusLock />
									</div>}> <OptixCheckout {...this.props} /> </Suspense>)} /> : ""}
									{/* <Route exact path="/floating-cart" component={FloatingCart} />
									<Route exact path="/bundle-floating-cart" component={BundleFloatingCart} /> */}
									<Route exact path="/save-cart" render={() => <SaveCart {...this.props} />} />
									<Route exact path="/save-cart-confirmation" component={SaveCartConfirmation} />
									{/* <Route exact path="/confirmation" component={Confirmation}  {...this.props} />
									<Route exact path="/optix-confirmation" component={OptixConfirmation}  {...this.props} /> */}
									<Route exact path="/confirmation" render={() => (<Suspense fallback={<div className="loading-spinner">
										<Loader active fullscreen disableFocusLock />
									</div>}> <Confirmation {...this.props} /> </Suspense>)} />
									<Route exact path="/optix-confirmation" render={() => (<Suspense fallback={<div className="loading-spinner">
										<Loader active fullscreen disableFocusLock />
									</div>}> <OptixConfirmation {...this.props} /> </Suspense>)} />
									{/* <Route exact path="/contact-rep" component={ContactRep}  {...this.props} /> */}
									<Route exact path="/confirmation-contact-rep" component={ConfirmationContactRep}  {...this.props} />
									{/* Redirect Route from a external application */}
									<Route exact path="/pendingOrder" component={RetrievePendingOrder}  {...this.props} />
									<Route exact path="/ExistingService" component={RetrieveExistingService}  {...this.props} />
									<Route exact path="/abandoned-cart" component={AbandonedCart}  {...this.props} />
									<Route exact path="/internet-options" component={InternetOptions}  {...this.props} />
									<Route exact path="/internet-services" component={InternetServices}  {...this.props} />
									<Redirect to="/" />
								</Switch>
							</Col>
						</Row>
					</Grid>
				</StyledContainer>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	const { AddressValidationPage, getCartInfoSuccessResponse, CheckoutPage} = state
	return {
		/* ADD STATE */
		toggleLoadingSpinner: AddressValidationPage.toggleLoadingSpinner,
		zipcodeSuggestionList: AddressValidationPage.zipcodeSuggestionList,
		zipcodeEnteredByUser: AddressValidationPage.zipcodeEnteredByUser,
		selectedZipcode: AddressValidationPage.selectedZipcode,
		streetTermEnteredByUser: AddressValidationPage.streetTermEnteredByUser,
		streetAddressSuggestionList: AddressValidationPage.streetAddressSuggestionList,
		selectedStreetAddress: AddressValidationPage.selectedStreetAddress,
		unitList: AddressValidationPage.unitList,
		enableCheckAvailability: AddressValidationPage.enableCheckAvailability,
		selectedUnit: AddressValidationPage.selectedUnit,
		phoneNumber: AddressValidationPage.phoneNumber,
		emailAddress: AddressValidationPage.emailAddress,
		priceQuoteNumber: AddressValidationPage.priceQuoteNumber,
		addressQualificationDetails: AddressValidationPage.addressQualificationDetails,
		optixAddressQualificationDetails: AddressValidationPage.optixAddressQualificationDetails,
		isExistingCustomer: AddressValidationPage.isExistingCustomer,
		// toggleGlobalErrorMessage: AddressValidationPage.toggleGlobalErrorMessage,
		hasPendingOrder: AddressValidationPage.hasPendingOrder,
		hasMultipleAddress: AddressValidationPage.hasMultipleAddress,
		totalUnits: AddressValidationPage.totalUnits,
		faqContent: AddressValidationPage.faqContent,
		getCartInfoSuccessResponse: getCartInfoSuccessResponse,
		lqPageAds: AddressValidationPage.lqPageAds,
		latestConvId: AddressValidationPage.latestConvId,
		unitsTriggered: AddressValidationPage.unitsTriggered,
		unitsResponded: AddressValidationPage.unitsResponded,
		isCreditCheckLBO: CheckoutPage?.isCreditCheckLBO
	}
}

const mapDispatchToProps = (dispatch) => ({
	initiateGlobalSession: () => {
		dispatch(initiateGlobalSession())
	},
	getApigeeToken: () => {
		dispatch(getApigeeToken())
	},
	getZipcodes: (userInput, skipStreetUpdate) => {
		dispatch(getZipcodes(userInput, skipStreetUpdate))
	},
	selectThisZipcode: (zipcode) => {
		dispatch(selectThisZipcode(zipcode))
	},
	getStreetAddress: (userInput) => {
		dispatch(getStreetAddress(userInput))
	},
	selectThisStreetAddress: (streetAddress) => {
		dispatch(selectThisStreetAddress(streetAddress))
	},
	getUnits: () => {
		dispatch(getUnits())
	},
	getUnitsByUnitterm: (data) => {
		dispatch(getUnitsByUnitterm(data))
	},
	selectThisUnit: (unit) => {
		dispatch(selectThisUnit(unit))
	},
	showCheckAvailability: () => {
		dispatch(showCheckAvailability())
	},
	savePhoneNumber: (phoneNumber) => {
		dispatch(savePhoneNumber(phoneNumber))
	},
	saveEmailAddress: (emailAddress) => {
		dispatch(saveEmailAddress(emailAddress))
	},
	savePriceQuoteNumber: (priceQuoteNumber) => {
		dispatch(savePriceQuoteNumber(priceQuoteNumber))
	},
	saveOptixMonNumber: (monNumber) => {
		dispatch(saveOptixMonNumber(monNumber));
	},
	triggerAddressQualification: (historyObjectForNavigation) => {
		dispatch(triggerAddressQualification(historyObjectForNavigation))
	},
	triggerOptixAddressQualification: (historyObjectForNavigation) => {
		dispatch(triggerOptixAddressQualification(historyObjectForNavigation))
	},
	getcartInfo: () => {
		dispatch(getcartInfo());
	},
	clearGlobalStore: () => {
		dispatch(clearGlobalStore())
	},
	clearFaqContent: () => dispatch(clearFaqContent()),
	saveConversationInfo: (data) => dispatch(saveConversationInfo(data)),
	setConversationID: (data) => dispatch(setConversationID(data)),
	getMultipleAddrSelections: (data) => { dispatch(getMultipleAddrSelections(data)) },
	postEventLogging: (data) => dispatch(postEventLogging(data)),
	getRetrieveOrder: (params) => { dispatch(getRetrieveOrder(params)) },
	setIsExternalAppRedirection: (params) => { dispatch(setIsExternalAppRedirection(params)) },
	getQulaificationDetails: (data) => { dispatch(getQulaificationDetails(data)) },
	redirectLBOPage: (data) => dispatch(redirectLBOPage(data)),
})

const GBPortalContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(GBPortal))
export default withTranslation("fios", { withRef: true })(GBPortalContainer)
